import React from 'react'
import { Checkbox, Menu as SemanticMenu, Sticky } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import authService from '../services/authentication';
import { BaseUser } from '../../../src/types';
import useControllerState from '../hooks/useControllerState';
import controllerService from '../services/controller';

const Menu = ({ user, setUser }: {user: BaseUser|undefined, setUser: Function}) => {
    const { controllerState, setControllerState } = useControllerState();
    const logout = () => {
        authService.removeAccessToken();
        setUser(undefined);
    }
    const toggleControllerState = async () => {
        await controllerService.setState(!controllerState);
        setControllerState(!controllerState);
    }

    return (
        <Sticky>
            <SemanticMenu>
                {user && 
                <SemanticMenu.Item header>
                    Welcome, {user.name}
                </SemanticMenu.Item>
                }
                <SemanticMenu.Item as={Link} to="/">
                Plants
                </SemanticMenu.Item>
                {!user && 
                <SemanticMenu.Item as={Link} to="/login" position="right">
                    Login
                </SemanticMenu.Item>
                }
                {user &&
                <SemanticMenu.Menu position="right">
                    <SemanticMenu.Item
                        onClick={toggleControllerState}
                        as={Checkbox}
                        toggle
                        label={controllerState ? "Turn Off": "Turn On"}
                        checked={controllerState}
                    />
                    <SemanticMenu.Item onClick={logout}>
                    Logout
                    </SemanticMenu.Item>
                </SemanticMenu.Menu>
                }
            </SemanticMenu>
        </Sticky>
    )
}

export default Menu;